import React from "react";
import { Helmet } from "react-helmet";

function FontLoad() {
  return (
    <Helmet>
      <script>
        {`${
          typeof document !== "undefined" &&
          (function (d) {
            var config = {
                scriptTimeout: 3000,
                async: true,
              },
              h = d.documentElement,
              t = setTimeout(function () {
                h.className =
                  h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
              }, config.scriptTimeout),
              tk = d.createElement("script"),
              f = false,
              s = d.getElementsByTagName("script")[0],
              a;
            h.className += " wf-loading";
            tk.src = `${process.env.GATSBY_TYPEKIT_URL}.js`;
            tk.async = true;
            tk.onload = tk.onreadystatechange = function () {
              a = this.readyState;
              if (f || (a && a !== "complete" && a !== "loaded")) return;
              f = true;
              clearTimeout(t);
              try {
                /* eslint-disable */
                Typekit.load(config);

                /* eslint-enable */
              } catch (e) {}
            };
            s.parentNode.insertBefore(tk, s);
          })(document)
        }`}
      </script>
    </Helmet>
  );
}

export default FontLoad;
